import React from 'react';
import useRating from '../hooks/use-rating';
import StyledStars from './styled-stars';

const StarsContainer = ({
  starsColor,
  starsColorBackground,
  companyId,
  siteId,
  ratingId,
  ratingIds,
  className,
}) => {
  const { score, maximumScore } = useRating({
    companyId,
    siteId,
    ratingId,
    ratingIds,
  });
  if (!score || !maximumScore) {
    return null;
  }
  return (
    <StyledStars
      className={className}
      $score={score}
      $maximumScore={maximumScore}
      $starsColor={starsColor}
      $starsColorBackground={starsColorBackground}
    />
  );
};

export default StarsContainer;
